import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'
import { settingsEditType } from '@internal/router/middleware/settings-edit-type'

export const settings = [
  {
    path: '/settings',
    name: ERouterList.SETTINGS,
    component: () => import('@internal/pages/settings/index.vue'),
    meta: {
      middleware: [auth],
      layout: InnerLayout,
    },
  },
  {
    path: '/settings/edit',
    name: ERouterList.SETTINGS_EDIT,
    component: () => import('@internal/pages/settings/edit.vue'),
    meta: {
      middleware: [settingsEditType, auth],
    },
  },
]

export default settings
